import { Box, Button as MButton, useTheme } from "@mui/material";

interface Props {
    value: boolean;
    onClick?: (val: boolean) => void;
}

const ToggleButton = (props: Props) => {
    const theme = useTheme();

    const { value, onClick } = props;

    return (
        <MButton
            variant="contained"
            size="small"
            sx={{
                height: "28px",
                width: "48px",
                minWidth: "48px",
                padding: 0,
                margin: 0,
                borderRadius: "15px",
                border: "none",
                display: "flex",
                backgroundColor: theme.palette.primary.main,
                opacity: value ? 1 : 0.2,
                justifyContent: value ? "flex-end" : "flex-start",
                textTransform: "none",
            }}
            onClick={() => onClick?.(!value)}
        >
            <Box
                width="24px"
                height="24px"
                bgcolor="white"
                borderRadius="24px"
                margin="2px"
            />
        </MButton>
    );
};

export default ToggleButton;
